import '@sophocles/styles/master.scss';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LicenseInfo } from '@mui/x-license';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';

import App from '@sophocles/app';
import { initializeApiClients } from '@sophocles/axiosInit';
import i18n from '@sophocles/i18n';
import tokenService from '@sophocles/services/token';
import { SocketProvider } from '@sophocles/socket-io/context';
import store from '@sophocles/store/redux-store';
import { configureYupValidation } from '@sophocles/utils/validation';

import { BluetoothProvider } from './components/bluetooth/BluetoothContext';

initializeApiClients(store);
LicenseInfo.setLicenseKey(__MUI_X_LICENSE_KEY__ || '');

require('../node_modules/@fortawesome/fontawesome-free/js/fontawesome');
require('../node_modules/@fortawesome/fontawesome-free/js/solid');
require('../node_modules/@fortawesome/fontawesome-free/js/regular');
require('es6-promise').polyfill();
require('@sophocles/public/favicon.ico');

tokenService.initialize();
configureYupValidation();

// SnackbarProvider lives in <App /> (inside ThemeSchemeProvider) so
// toast components inherit the active MUI theme — otherwise notistack
// portals render with MUI's default light theme and dark mode toasts
// become unreadable.
createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <BluetoothProvider>
          <SocketProvider>
            <App />
          </SocketProvider>
        </BluetoothProvider>
      </LocalizationProvider>
    </I18nextProvider>
  </Provider>,
);
